// src/Icons/GaussIcon.jsx
import React from 'react';

const DecompositionIcon = ({ size = 40, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
   
    {/* Column lines */}
    <line x1="5" y1="10" x2="5" y2="90" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="95" y1="10" x2="95" y2="90" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="5" y1="13" x2="15" y2="13" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="5" y1="87" x2="15" y2="87" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="95" y1="13" x2="85" y2="13" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="95" y1="87" x2="85" y2="87" stroke="#f3f4f6" strokeWidth="6" />

    {/* Right side (solution vector) */}
    {/*<line x1="18" y1="20" x2="78" y2="80" stroke="#f3f4f6" strokeWidth="5" strokeDasharray="6"/>*/}

    <polygon points="15,78 15,25 72,78" fill="none" stroke="#f3f4f6" strokeWidth="5" strokeDasharray="8" />
    <polygon points="28,22 85,22 85,75" fill="none" stroke="#f3f4f6" strokeWidth="5" />
{/*
    <text x="30" y="65" fontSize="45" textAnchor="middle" fill="#f3f4f6" dominantBaseline="middle" fontWeight="bold">
        L
    </text>

    <text x="65" y="35" fontSize="45" textAnchor="middle" fill="#f3f4f6" dominantBaseline="middle" fontWeight="bold">
        U
    </text>
*/}



  </svg>
);

export default DecompositionIcon;
